/**
 * Which hub devices are covers.
 *
 * Hubs name the control a cover carries `cover`, but the family runs wider
 * (`roller_shutter`, `curtain_motor`, `awning`, `window_cover`) and the hub's own
 * definition lists the same words. They are matched against the *words* a name is
 * built from, never as a bare substring: a substring test read `roller` out of
 * `sauna_controller` and `heat_demand_controller`, so a sauna and a heat-demand
 * controller were adopted as shades.
 */

/** Control hints that mark a cover device — mirrors the hub's definition. */
const COVER_CONTROL_HINTS = ['blind', 'cover', 'shade', 'roller', 'curtain', 'awning', 'window'];

/** The fields a device names its control in, as the hubs spell them. */
export interface ShadeCandidate {
  deviceControl?: string | null;
  controlType?: string | null;
  deviceType?: string | null;
}

function declaresCoverHint(value: string | null | undefined): boolean {
  const words = (value ?? '')
    .trim()
    .toLowerCase()
    .split(/[^a-z0-9]+/);
  return words.some((word) => word !== '' && COVER_CONTROL_HINTS.some((hint) => word.startsWith(hint)));
}

export function isShadeDevice(device: ShadeCandidate): boolean {
  return declaresCoverHint(device.deviceControl ?? device.controlType) || declaresCoverHint(device.deviceType);
}
